/**
 * Kanonik URL ve Open Graph için site kökü.
 * Üretimde `REACT_APP_SITE_URL` (örn. https://www.ornek.org) tanımlayın;
 * tanımlı değilse tarayıcıda `window.location.origin` kullanılır.
 * @returns {string}
 */
export function getSiteUrl() {
    const env = process.env.REACT_APP_SITE_URL;
    if (env && String(env).trim()) {
        return String(env).replace(/\/$/, '');
    }
    if (typeof window !== 'undefined' && window.location?.origin) {
        return window.location.origin;
    }
    return '';
}
